var _a;
/**
 * Provides common utilities to activate & use Datadog RUM
 *
 * @packageDocumentation
 */
/* istanbul ignore file */
import { registerLibrary } from '@onviobr/app-information';
export { defaultScrubConfig, makeDataScrubber, initializeDatadog, setDatadogUserContext, ONVIO_DOMAINS, LOCAL_DOMAINS, } from './datadog.js';
registerLibrary({
    name: '@onviobr/datadog',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    version: (_a = "2.2.0") !== null && _a !== void 0 ? _a : '0.0.0',
});
